import api from "../../../../../../api";
import React, { useState } from "react";
import values from "../../../../../../values";
import Context from "../../../../../../context";

import * as Yup from "yup";

import { useFormik } from "formik";
import { useQuery } from "react-query";
import {
  ICityItem,
  IProvinceItem,
} from "../../../../../../types/common.interface";
import { ICreateAndUpdateSuperAgent } from "../../../../../../types/superAgent.interface";
import {
  CustomButton2,
  CustomDropdownSearch,
  CustomIcon,
  CustomInput,
  CustomModal,
  CustomView,
} from "../../../../../../components";

import "./index.sass";
import TitleLine from "../../../../../../components/TitleLine";
import validations from "../../../../../../validations";
import utils from "../../../../../../utils";
import { useTranslation } from "react-i18next";

const Create = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, createFunction, isLoading } =
    React.useContext(Context.SuperAgentCityScreen);
  const [selectedCity, setSelectedCity] = React.useState<ICityItem>();
  const [selectedProvince, setSelectedProvince] =
    React.useState<IProvinceItem>();
  const [dropDownErrors, setDropDownErrors] = useState<any>({
    province: "",
    city: "",
  });
  const [selectedFinancialGroup, setSelectedFinancialGroup] =
    React.useState<any>(undefined);
  const { t } = useTranslation();

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------
  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.get.common.getAllProvince()
  );

  const getAllCity = useQuery(
    [values.useQueryKeys.getAllCity, selectedProvince],
    () => api.get.common.getAllCity({ provinceCode: selectedProvince?.Code })
  );

  const getAllFinancilalGroup = useQuery(
    [values.useQueryKeys?.getAllFinancialGroup],
    () =>
      api.post.administrator.getAllFinancialGroup({
        filters: { FinancialGroupType: "company" },
      })
  );

  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================

  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------

  const formik = useFormik<ICreateAndUpdateSuperAgent>({
    enableReinitialize: true,
    initialValues: {
      address: "",
      lastName: "",
      firstName: t("superAgent"),
      kartNumber: "",
      phoneNumber: "",
      shabaNumber: "",
      nationalCode: "",
    },
    validationSchema: Yup.object({
      // validation
      address: validations.yupValidations.address,
      lastName: validations.yupValidations.lastName,
      firstName: validations.yupValidations.firstName,
      kartNumber: validations.yupValidations.kartNumber,
      phoneNumber: validations.yupValidations.phoneNumber,
      shabaNumber: validations.yupValidations.shabaNumber,
      nationalCode: validations.yupValidations.nationalCode,
    }),
    onSubmit: (values: ICreateAndUpdateSuperAgent, { setSubmitting }) => {
      const formValues: ICreateAndUpdateSuperAgent = {
        ...values,
        city: selectedCity,
        province: selectedProvince,
        financialGroupSchool: selectedFinancialGroup?._id,
      };
      if (selectedProvince && selectedCity && selectedFinancialGroup) {
        Promise.resolve(createFunction(formValues))
          .then((value) => {
            if (value) {
              setSelectedCity(undefined);
              setSelectedProvince(undefined);
              setSelectedFinancialGroup(undefined);
              formik.resetForm();
            }
          })
          .catch((e) => setSubmitting(false));
      }
    },
  });

  const submitHandler = () => {
    // validation
    let errors = {};
    if (!selectedProvince) {
      errors = {
        ...errors,
        province: t("province_is_required"),
        city: t("city_is_required"),
      };
    } else if (!selectedCity) {
      errors = {
        ...errors,
        city: t("city_is_required"),
      };
    }
    if (!selectedFinancialGroup) {
      errors = {
        ...errors,
        financialGroup: t("financial_group_is_required"),
      };
    }

    setDropDownErrors({
      ...errors,
    });

    formik.submitForm();
  };

  // ?? ===========================================================================================================
  // ??                                               JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="super-agent-create-modal-container">
      <CustomIcon
        icon="fa-sharp fa-solid fa-circle-plus"
        size="medium"
        hoverTitle={t("createEducation")}
        onClick={() => {
          setShowModal("CREATE");
        }}
      />
      <form onSubmit={submitHandler}>
        <CustomModal
          onClose={() => setShowModal("NONE")}
          open={showModal === "CREATE"}
        >
          <CustomView.Container className="create-form-content">
            <TitleLine title={t("address")} />
            <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum dropdown">
                <label className="form-label">{t("province")}</label>
                <CustomDropdownSearch
                  items={getAllProvince?.data?.result}
                  itemName="Name"
                  defaultItem={selectedProvince}
                  onSelectItem={(event: IProvinceItem) => {
                    setSelectedCity(undefined);
                    setSelectedProvince(event);
                    setDropDownErrors({ ...dropDownErrors, province: "" });
                  }}
                  placeHolder={t("selectProvince")}
                  isLoading={getAllProvince.isLoading}
                  isSearch
                />
                <div className="error">
                  {dropDownErrors.province !== "" && dropDownErrors.province}
                </div>
              </CustomView.Column>
              <CustomView.Column medium={6} className="form-colum dropdown">
                <label className="form-label">{t("city")}</label>
                <CustomDropdownSearch
                  items={getAllCity?.data?.result}
                  itemName="Name"
                  defaultItem={selectedCity}
                  onSelectItem={(event: ICityItem) => {
                    setSelectedCity(event);
                    setDropDownErrors({ ...dropDownErrors, city: "" });
                  }}
                  placeHolder={t("selectProvince")}
                  isLoading={getAllCity.isLoading}
                  isSearch
                />
                <div className="error">
                  {dropDownErrors.city !== "" && dropDownErrors.city}
                </div>
              </CustomView.Column>
            </CustomView.Row>
            {/* <TitleLine title="اطلاعات مسئول مربوطه" /> */}

            <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum">
                <CustomInput
                  name="firstName"
                  id="firstName"
                  label={t("firstName")}
                  value={formik.values.firstName}
                  //onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.firstName && formik.touched.firstName}
                  errorText={formik.errors.firstName}
                />
              </CustomView.Column>
              <CustomView.Column medium={6} className="form-colum">
                <CustomInput
                  name="lastName"
                  id="lastName"
                  label={t("city")}
                  value={formik.values.lastName}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.lastName && formik.touched.lastName}
                  errorText={formik.errors.lastName}
                />
              </CustomView.Column>
            </CustomView.Row>
            <CustomView.Row className="form-row">
              <CustomView.Column medium={12} className="form-colum">
                <CustomInput
                  name="address"
                  id="address"
                  label={t("address")}
                  value={formik.values.address}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.address && formik.touched.address}
                  errorText={formik.errors.address}
                />
              </CustomView.Column>
            </CustomView.Row>

            <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum">
                <CustomInput
                  name="nationalCode"
                  id="nationalCode"
                  label={t("nationalCode")}
                  value={utils.convertNumbers2English(
                    formik.values.nationalCode as string
                  )}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={
                    formik.errors.nationalCode && formik.touched.nationalCode
                  }
                  errorText={formik.errors.nationalCode}
                  maxLength={10}
                />
              </CustomView.Column>

              <CustomView.Column medium={6} className="form-colum">
                <CustomInput
                  name="phoneNumber"
                  id="phoneNumber"
                  label={t("phoneNumber")}
                  value={utils.convertNumbers2English(
                    formik.values.phoneNumber as string
                  )}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={
                    formik.errors.phoneNumber && formik.touched.phoneNumber
                  }
                  errorText={formik.errors.phoneNumber}
                  maxLength={11}
                />
              </CustomView.Column>
            </CustomView.Row>
            <TitleLine title={t("financialInfo")} />
            <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum dropdown">
                <label className="form-label">{t("financialGroup")}</label>
                <CustomDropdownSearch
                  items={getAllFinancilalGroup?.data?.result}
                  itemName="name"
                  defaultItem={selectedFinancialGroup}
                  onSelectItem={(event: any) => {
                    setSelectedFinancialGroup(event);
                    setDropDownErrors({
                      ...dropDownErrors,
                      financialGroup: "",
                    });
                  }}
                  placeHolder={t("selectFinancialGroup")}
                />
                <div className="error">
                  {dropDownErrors.financialGroup !== "" &&
                    dropDownErrors.financialGroup}
                </div>
              </CustomView.Column>
              <CustomView.Column medium={6} className="form-colum">
                <CustomInput
                  name="kartNumber"
                  id="kartNumber"
                  label={t("cardNumber")}
                  value={utils.convertNumbers2English(
                    formik.values.kartNumber as string
                  )}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.kartNumber && formik.touched.kartNumber}
                  errorText={formik.errors.kartNumber}
                  maxLength={16}
                />
              </CustomView.Column>
            </CustomView.Row>
            <CustomView.Row className="form-row">
              <CustomView.Column medium={12} className="form-colum">
                <CustomInput
                  name="shabaNumber"
                  id="shabaNumber"
                  label={t("shabaNumber")}
                  value={utils.convertNumbers2English(
                    formik.values.shabaNumber as string
                  )}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={
                    formik.errors.shabaNumber && formik.touched.shabaNumber
                  }
                  errorText={formik.errors.shabaNumber}
                  isShaba
                  maxLength={24}
                />
              </CustomView.Column>
            </CustomView.Row>
            <CustomView.Row className="form-row buttons-group">
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                <CustomButton2
                  isLoading={isLoading}
                  onClick={() => setShowModal("NONE")}
                  title={t("cancel")}
                  type="danger"
                />
              </CustomView.Column>
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                <CustomButton2
                  isLoading={isLoading}
                  onClick={submitHandler}
                  title={t("submit")}
                />
              </CustomView.Column>
            </CustomView.Row>
          </CustomView.Container>
        </CustomModal>
      </form>
    </section>
  );
};

export default Create;
